import { Getters, Mutations } from "vuex";
import {
  SerialCodeState,
  SerialCodeGetters,
  SerialCodeMutations,
} from "./types";

const state: SerialCodeState = {
  serialCodes: {},
};

const getters: Getters<SerialCodeState, SerialCodeGetters> = {
  serialCode: (state) => (campaignUrlCode: string) =>
    state.serialCodes[campaignUrlCode] ?? "",
};

const mutations: Mutations<SerialCodeState, SerialCodeMutations> = {
  setSerialCode(state, { campaignUrlCode, code }) {
    state.serialCodes = { ...state.serialCodes, [campaignUrlCode]: code };
  },
  clearSerialCode(state, { campaignUrlCode }) {
    const { [campaignUrlCode]: _, ...rest } = state.serialCodes;
    state.serialCodes = rest;
  },
};

const serialCodeModule = {
  namespaced: true,
  state,
  getters,
  mutations,
};

export default serialCodeModule;
